export const moduleId = 'settlementDocument';

export const state = {
    lists: {},
    isDetail: false,//详情显示隐藏
    dialogzt: false,//账套显示隐藏
    flag: false,//是否可编辑
    orgId: '',
    isShow: true,
    routeSource: false,
    id: '',
    isRouter: false,
    isDeapproval: false,
    isAdd: true,
    abId: '',
}
export const mutations = {
    setisDetail(state, data) {
        state.isDetail = data
    },
    //判断点击的是否是详情
    setRouteSource(state, data) {
        state.routeSource = data
    },
    setDialogzt(state, data) {
        state.dialogzt = data
    },
    setOrgList(state, data) {

        state.lists = data
    },
    setFalg(state, data) {
        state.flag = data
    },
    setIsRouter(state, data) {
        state.isRouter = data
    },
    setIsDeApproval(state, data) {
        state.isDeapproval = data
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/settlement-center/settlement-document/index.js